import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import clsx from 'classnames';
import { EButtonType } from '../button.types';

type TPreloader = {
  className?: string;
  color?: string;
  styleType: EButtonType;
};

export const Preloader = styled(
  ({ className }: PropsWithChildren<TPreloader>): JSX.Element => (
    <div className={clsx(className, 'lds-ring')}>
      <div> </div>
      <div> </div>
      <div> </div>
      <div> </div>
    </div>
  ),
)<TPreloader>`
    &.lds-ring {
        display: inline-block;
        position: relative;
        width: 16px;
        height: 16px;
    }
    &.lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 16px;
        height: 16px;
        border: 2px solid ${({ theme }) => theme.branding.primary.main};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${({ theme }) => theme.branding.primary.main} transparent
            transparent transparent;

        ${({ styleType, theme }) => {
  switch (styleType) {
    case EButtonType.Outline:
      return css``;
    case EButtonType.Contrast:
      return css`
                        border-color: ${theme.branding.gray.darker} transparent
                            transparent transparent;
                    `;
    default:
    case EButtonType.Primary:
      return css`
                        border-color: ${theme.branding.white.lighter}
                            transparent transparent transparent;
                    `;
  }
}};
    }
    &.lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    &.lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    &.lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    ${({ theme }) => theme.mixins.flexCenter};
`;
